module.exports = __webpack_public_path__ + "static/media/example03-02.5021c96d.svg";